import { render, staticRenderFns } from "./UserInvitationsList.vue?vue&type=template&id=196375e4&scoped=true"
import script from "./UserInvitationsList.vue?vue&type=script&lang=js"
export * from "./UserInvitationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196375e4",
  null
  
)

export default component.exports